export default __webpack_public_path__ + "traffic-signs-header-image-480-95dfe5585b67a512d64921af712e0c28.webp";